<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="mainconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Reason</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Reason</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			{{ ToggleText }}
		</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Reason</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstVisitorReason"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorReason"
		dataKey="VisitorReasonID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--VisitorReasonDesc-->
				<th>
					<p-columnFilter type="text" field="VisitorReasonDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--CanEditDesc-->
				<th>
					<p-columnFilter field="CanEditDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCanEditDesc
								[ngModel]="value"
								[options]="lstCanEditDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="VisitorReasonDesc">Reason<p-sortIcon field="VisitorReasonDesc"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="CanEditDesc">Editable<p-sortIcon field="CanEditDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-VisitorReason>
			<tr [pSelectableRow]="VisitorReason" (dblclick)="onRowDblClick(VisitorReason)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorReason.VisitorReasonDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="VisitorReason.DefinedByID > 2 ? 'Black' : 'Red'">
					{{ VisitorReason.DefinedByDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="VisitorReason.Active == true ? 'Black' : 'Red'">
					{{ VisitorReason.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="VisitorReason.CanEdit == true ? 'Black' : 'Red'">
					{{ VisitorReason.CanEditDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
